import '../styles/app.scss';
import '@angular/compiler';

import { NgModule, Inject } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UpgradeModule } from '@angular/upgrade/static';
import { TranslateModule } from '@ngx-translate/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';

import { concat } from 'lodash';

import { components } from './components';
import { services } from './services';
import { AjsUpgradedProviders } from './ajs-upgraded-providers';
import { WithCredentialsInterceptor } from './services/with-credentials.interceptor';

/**
 * Core content upgraded to ng10
 */
@NgModule({
  id: 'newCoreModule',
  declarations: components,
  // expose all components to ng2+ modules use this module
  exports: components,
  providers: concat(services, AjsUpgradedProviders, [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true,
    },
  ]),
  imports: [
    TranslateModule.forRoot(),
    // to be removed once ng1+ is dropped
    UpgradeModule,
    BrowserAnimationsModule,
    HttpClientModule,

    FontAwesomeModule,
  ],
})
export class NewCoreModule {
  constructor(
    @Inject(TranslateService) private translateService: TranslateService,
  ) {
    // supported i18n list
    this.translateService.setTranslation(
      'nl-nl',
      require('../translations/nl-nl.json'),
    );
    this.translateService.setTranslation(
      'en-gb',
      require('../translations/en-gb.json'),
    );
    this.translateService.setTranslation(
      'fr-fr',
      require('../translations/fr-fr.json'),
    );
    this.translateService.setTranslation(
      'de-de',
      require('../translations/de-de.json'),
    );
    this.translateService.setTranslation(
      'it-it',
      require('../translations/it-it.json'),
    );
    this.translateService.setTranslation(
      'es-es',
      require('../translations/es-es.json'),
    );
  }
}
